import { ActionHistory } from "models/action-history";
export const actionHistory = new ActionHistory("block");
export const designActionHistory = new ActionHistory("design");
export const combinedActionHistory = new ActionHistory("combined");
export function clearHistory() {
  actionHistory.clear();
  designActionHistory.clear();
  combinedActionHistory.clear();
}
